<div class="message-container" #scrollMe [scrollTop]="scrollMe.scrollHeight">

    @if (!requestId) {
    <div class="alert">{{'REQUEST.ALERT.CAN_SEND_MESSAGE' | translate}}</div>
    } @else {
    @if(isLoading){
    <div class="table-loading">
        <mat-spinner strokeWidth="3" [diameter]="30"></mat-spinner>
    </div>
    } @else {
    @for (item of messages; track $index) {
    <!--customer message-->
    <div *ngIf="item.sendBy === sendByType.CUSTOMER" class="personal-message my-message">
        <div class="text">
            <span>
                {{item.comment}}
            </span>
            <div class="attachment" *ngIf="item.attachment">
                <div>
                    <span class="dl pointer" *ngIf="item.attachment" (click)="downloadDocument(item)">
                        <i class="icon-download"></i>{{item.attachment.displayName}}</span>
                </div>
                <div>
                    <tc-star-rating *ngIf="item.senderIsExpert" count="5" [value]="item.rate"></tc-star-rating>
                </div>
            </div>
            <div class="file-progress" *ngIf="item.isUploading">
                @if(isCryptoWithdraw && queueProgress > 0){
                <i class=" fa-spin fa-solid fa-spinner"></i>
                }@else {
                <ng-container *ngIf="queueProgress > 0">
                    <mat-progress-spinner [value]="queueProgress" [diameter]="33">
                    </mat-progress-spinner>
                    <span class="percent">{{queueProgress}}%</span>
                </ng-container>
                }
            </div>
        </div>
        <div class="time">
            <span *ngIf="item.sendDateUtc" tcdate [type]="dateTypes.DateTime" [value]="item.sendDateUtc"></span>
        </div>
        <div class="img">
            <img src="assets/media/images/proImg/default-males.png">
        </div>

    </div>
    <!--tc message-->
    <div *ngIf="item.sendBy === sendByType.EXPERT" class="personal-message tc-message">
        <div class="img">
            <img src="assets/media/images/Logo/tc-logo.svg">
        </div>
        <div class="text">
            <span>
                {{item.comment}}
            </span>
            <div class="attachment" *ngIf="item.attachment">
                <div>
                    <span class="dl pointer" *ngIf="item.attachment" (click)="downloadDocument(item)"><i
                            class="icon-download"></i>{{item.attachment.displayName}}</span>
                </div>
                <div>
                    <tc-star-rating *ngIf="item.senderIsExpert" count="5" [value]="item.rate"></tc-star-rating>
                </div>
            </div>
        </div>
        <div class="time">
            <span tcdate [type]="dateTypes.DateTime" [value]="item.sendDateUtc"></span>
        </div>
    </div>
    } @empty {
    <div class="alert message-empty">
        <img src="./assets/media/images/request/empty-message.png">
        {{'REQUEST.ALERT.THERE_IS_NO_MESSAGE_NEW' | translate}}
    </div>
    }
    }
    }
</div>
<div class="send-message-container" tcClickOutSide (clickOutside)="closeSendMessage()" *ngIf="requestId && canActive">
    <div class="send-message">
        <div class="footer" [ngClass]="{'is-open': textareaAnimationState==='in', 'crypto-withdraw': isCryptoWithdraw}">
            <form [formGroup]="form" [ngClass]="{'invalid': isInvalid}">
                <textarea class="textarea" (click)="openSendMessage()" formControlName="comment"
                    [placeholder]="placeHolder | translate" cols="30" rows="5"></textarea>
                <div class="add-file" *ngIf="filesToUpload && filesToUpload.length>0">
                    <div class="added-item" *ngFor="let item of filesToUpload">
                        <i class="icon-cancel close" style="color: white;" (click)="removeFile(item)"></i>
                        <div class="gradiant"></div>
                        <img src="./assets/media/images/request/file-attachment.svg">

                        @if(isCryptoWithdraw){
                        @if(isLoadingUploadImage){
                        <span class="loading-upload">
                            <i class="fa-spin fa-solid fa-spinner"></i>
                        </span>
                        }
                        }
                    </div>
                    <div class="add-item" (click)="attachment.click()">
                        <i class="icon-plus"></i>
                        <span>{{'GENERAL.CHANGE_FILE' | translate}}</span>
                    </div>
                </div>
                @if(isCryptoWithdraw && isLoadingUploadImage){
                <span class="icon-loading-send icon-send-disabled">
                    <i class=" fa-spin fa-solid fa-spinner"></i>
                </span>
                } @else if(isCryptoWithdraw && isLoadingSendMessage){
                <span class="icon-loading-send icon-send-disabled">
                    <i class=" fa-spin fa-solid fa-spinner"></i>
                </span>
                }@else{
                <i class="icon-send" [class.icon-send-float]="(filesToUpload && filesToUpload.length>0)"
                    [class.icon-send-disabled]="(f.comment.value.length<1 && filesToUpload.length<1)"
                    (click)="onSubmit()"></i>
                }
                <mat-icon *ngIf="!filesToUpload || filesToUpload.length<1" class="icon-attach-file"
                    [ngClass]="{'icon-attach-file-withdraw': isCryptoWithdraw}"
                    (click)="attachment.click()">attach_file</mat-icon>
                <input style="display: none;" [accept]="allowedExt" type="file" (change)="selectFile($event)"
                    #attachment>
            </form>

        </div>
    </div>
</div>

<div class="conversation-closed" *ngIf="requestId && !canActive">{{'REQUEST.CONVERSATION_CLODES' | translate}}</div>